import { sub } from 'date-fns';
import { TranslationResource } from './types';
import { is } from 'date-fns/locale';
import { ScanQrCode, School } from 'lucide-react';

export const french = {
  translation: {
    accounts: {
      coachAccount: "Compte Coach",
      studentAccount: "Compte élève",
      parentAccount: "Compte Parent",
      schoolAccount: "Compte école",
      schoolAdminAccount: "Compte école",
      schoolTeacherAccount: "Compte Professeur d'école"
    },
    profile:{
      title: "Mon Compte",
      subTitle: "Gérer vos informations de profil",
      firstname: "Prénom",
      lastname: "Nom",
      email: "Email",
      save: "Enregistrer",
      connected: "Connecté",
      accountType: "Type de compte",
      companyName: "Nom de l'école",
      teacherConnectedToSchool: "École",
      teacherConnectedToCoach: "Professeur",
      Tabs:{
        profile: "Profil",
        billing: "Facturation",
        subscritpion: "Mon Abonnement",
        security: "Sécurité",
        sessions:  "Sessions",
        mySchool: "Mon École",
        referral: "Parrainage",
        logout: "Déconnexion",
        notifications: "Notifications",
        invitation: "Invitation",
        join: "Rejoindre",
        help: "Aide",
        support: "Support",
      },
      help: {
        subtitle: "Comment pouvons-nous vous aider ?",
        checklistTitle: "Les étapes à réaliser pour bien démarrer",
        createCategory: "Comment créer une catégorie ?",
        createStudent: "Comment créer un étudiant ?",
        createEvent: "Comment créer un événement ?",
        restart: "Redémarrer le Tutoriel ?",
      },
      security_subTitle: "Gérer la sécurité de votre compte",
      twoFactorAuth: "Authentification à deux facteurs",
      enable2FA: "Activer le 2FA",
      TwoFA_explication: "Activer l'authentification à deux facteurs pour renforcer la sécurité de votre compte.",
      noChangePassword: "Les modifications de mot de passe ne sont pas disponibles lorsque vous êtes connecté avec des comptes Apple ou Google",
      subscription_subTitle: "Gérer votre abonnement et votre moyen de paiement",
      currentPlan: "Abonnement actuel",
      Trial: "Période d'Essai",
      active: "Actif",
      free: "Gratuit",
      your_trial_ends: "Votre période d'essai se termine le",
      paymentMethods: "Moyens de paiement",
      billingHistory: "Historique de facturation",
      your_next_billing_date: "Votre prochaine date de facturation est le",
      perMonth: "/mois",
      changePlan: "Changer d'abonnement",
      noActiveSubscription: "Aucun abonnement actif.",
      noActiveSubscriptionExplication: "Vous pouvez souscrire à un abonnement pour accéder aux fonctionnalités premium",
      willBeCancel: "annulation",
      subscribeNow: "S'abonner maintenant",
      expires: "Expire le",
      edit: "Modifier",
      delete: "Supprimer",
      premiumPlan: "Abonnement Premium",
      fullAccess: "Accès complet",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      changePassword: "Changer le mot de passe",
      cancelSubscription: "Annuler l'abonnement",
      confirmCancel: "Êtes-vous sûr de vouloir annuler votre abonnement à ThePoppyApp ?",
      yesConfirm: "Oui, je confirme !",
      validUntil: "Votre abonnement sera encore valide jusqu'au",
      cancelSuccess: "Annulation de l'abonnement",
      cancelSuccessDesc: "Votre abonnement a bien été annulé et prendra fin le",
      cancelError: "Une erreur est produite. Veuillez réessayer dans quelques instants",
      codePromo: "Vous bénéficiez actuellement d'une réduction de {{percent_off}}% sur votre abonnement",
      discount: "Réduction",
      noCancel: "Ne pas annuler",
      noCancelDesc: "Vous avez récement demander l'annulation de votre abonnement ThePoppyApp. Souhaitez-vous ne plus annuler et garder votre abonnement ?",
      noCancelSuccess: "Abonnement rétabli",
      noCancelSuccessDesc: "Votre abonnement est activé",
      changeCard: "Changer de moyen de paiement",
      changeCardDesc: "Ce nouveau moyen de paiement sera utilisé pour vos futurs mensualités pour payer votre abonnement ThePoppyApp",
      updatePaymentMethod: "Mettre à jour",
      manageProfileAvatar: "Image de profile",
      uploadAvatar: "Ajouter une image",
      changeAvatar: "Changer mon image",
      addCoupon: "Entrez un code promo qui sera appliqué sur votre prochaine facture",
      coupon: "Coupon",
      changeHasBeenApplied: "Le changement a été appliqué à votre compte",
      updateFailed: "La mise à jour a échoué,",
      pleaseRetry: "Veuillez réessayer",
      paymentMethodSaved: "Votre moyen de paiement a été mis à jour avec succès",
      sessionLoggedOut: "Session déconnectée",
      sessionLoggedOutDesc: "La session a été déconnectée avec succès",
      newPasswordNotMatch: "Nouveaux mots de passe ne correspondent pas",
      passwordUpdated: "Mot de passe mis à jour",
      yourPasswordChanged: "Votre mot de passe a été changé avec succès",
    },
    deleteAccount: {
      title: "Supprimer votre compte",
      description: "Êtes-vous sûr de vouloir supprimer votre compte ? Vous allez recevoir un email pour confirmer la suppression de votre compte.",
      confirm: "Demander la suppression de mon compte",
      lastConfirmation: "Veuillez confirmer que vous souhaitez procéder à cette action irréversible.",
      requestSent: "Demande envoyée",
      emailConfirmation: "Veuillez consulter vos emails pour confirmer la suppression de votre compte.",
      deleteMyAccount: "Supprimer mon compte",
      confirmDeleteTitle: "Confirmer la suppression",
      confirmDeleteDesc: "Confirmer la suppression de votre compte entraînera la suppression définitive de votre compte et de toutes vos données associées. Cette action est irréversible.",
      confirmDelete: "Confirmer la suppression",
      deleteAccountWarning: "Une fois votre compte supprimé, il n'y a pas de retour en arrière. Soyez certain de votre choix.",
      confirmedDeleteTitle: "Suppression confirmée",
      deleteSuccessMessage: "Votre compte a été supprimé avec succès. Nous sommes désolés de vous voir partir. Si vous changez d'avis, n'hésitez pas à créer un nouveau compte et à nous rejoindre à nouveau !",
    },
    common: {
      timezone: "Fuseau horaire",
      actions: "Actions",
      send: "Envoyer",
      allRightsReserved: "Tous droits réservés",
      failedNetwork: "Requête impossible. Vérifiez votre connexion internet",
      selectAll: "Tout sélectionner",
      deselectAll: "Tout désélectionner",
      ok: "OK",
      hide: "Cacher",
      apply: "Appliquer",
      reset: "Réinitialiser",
      selectTimezone: "Sélectionnez un fuseau horaire",
      sending: "Envoi en cours...",
      processing: "Traitement en cours...",
      deleting: "Suppression en cours...",
      username: "Choisissez un identifiant de connexion",
      firstName: "Prénom",
      lastName: "Nom",
      done: "Valider",
      email: "Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      login: "Se connecter",
      register: "S'inscrire",
      name: "Nom complet",
      loading: "Chargement...",
      forgotPassword: "Mot de passe oublié ?",
      submit: "Soumettre",
      cancel: "Annuler",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      search: "Rechercher",
      filters: "Filtres",
      all: "Tout",
      add: "Ajouter",
      remove: "Retirer",
      confirm: "Confirmer",
      yes: "Oui",
      no: "Non",
      back: "Retour",
      next: "Suivant",
      continue: "Continuer",
      create: "Créer",
      update: "Mettre à jour",
      view: "Voir",
      preview: "Aperçu",
      download: "Télécharger",
      downloadApp: "Télécharger l'application",
      backToLogin: "Retour à la connexion",
      learnMore: "En savoir plus",
      getStarted: "Commencer",
      success: "Succès !",
      error: "Erreur !",
      offlineMessage: "Vous êtes actuellement hors ligne. Certaines fonctionnalités peuvent ne pas être disponibles.",
      onlineMessage: "Votre connexion est rétablie.",
      dismiss: "Ignorer",
      country: "Pays",
      addNew: "Ajouter un nouveau",
      close: "Fermer",
      save_change: "Enregistrer les modifications",
      sendAt: "Envoyé à",
      to: "à",
      newEventAdded: "Nouvel événement ajouté",
      with: "avec",
    },

    nav: {
      home: "Accueil",
      agenda: "Agenda",
      students: "Étudiants",
      teachers: "Professeurs",
      invoices: "Facturation",
      messagerie: "Messagerie",
      reports: "Rapports",
      settings: "Paramètres",
      profile: "Profil",
      account: "Compte",
      myAccount: "Mon Compte",
      logout: "Déconnexion",
      help: "Aide",
      support: "Support",
      feedback: "Retour",
      pricing: "Tarifs",
      features: "Fonctionnalités",
      contact: "Contact",
      about: "À propos",
      legal: "Légal",
      terms: "Conditions",
      privacy: "Confidentialité",
      faq: "FAQ",
      documentation: "Documentation"
    },

    login: {
      title: "Connexion",
      username: "Identifiant de connexion",
      usernamePlaceholder: "Entrez votre identifiant",
      password: "Mot de passe",
      addAnotherAccount: "Ajouter un autre compte",
      addAnotherAccountDesc: "Connectez-vous à un autre compte ThePoppyApp pour passer facilement de l'un à l'autre",
      switchAccount: "Changer de compte",
      loginSuccess: "Connexion réussie",
      loginFailed: "Échec de la connexion",
      logout: "Déconnexion",
      loggout: "Déconnexion réussie",
      loggoutFailed: "Échec de la déconnexion",
      loggoutSuccessDesc: "Vous avez été déconnecté avec succès",
      connectedWithGoogle: "Connecté avec votre compte Google",
      pleaseTryAgain: "Veuillez vérifier vos identifiants et réessayer",
      subtitle: "Entrez vos identifiants pour accéder à votre compte",
      orContinueWith: "Ou continuer avec",
      noAccount: "Vous n'avez pas de compte ?",
      createAccount: "Créer un compte",
      continueWithApple: "Continuer avec Apple",
      continueWithGoogle: "Continuer avec Google",
      twoFaTitle: "Authentication à deux facteurs",
      twoFaSubtitle: "Entrez le code de votre application d'authentification pour continuer",
      verif: "Vérifier",
      twoFaDescription: "Protégez votre compte avec un code à 6 chiffres généré par votre application d'authentification (Google Authenticator, Authy, 1Password…).",
      activate2FABtn: "Activer",
      desactivate2FABtn: "Désactiver",
      twoFAEnabled: "Activé",
      twoFADisabled: "Désactivé",
      addAccountTOAuthApp: "Ajoutez ce compte à votre application d'authentification",
      ScanQrCode: "Scannez le QR code avec votre application d'authentification",
      secretKey: "Clé secrète",
      account: "Compte",
      issuer: "Émetteur",
      iAddedAccount: "J'ai ajouté le compte à mon application d'authentification",
      enterCode: "Entrez le code à 6 chiffres de votre application d'authentification",
      accountProtected: "Votre compte est désormais protégé avec l'authentification à deux facteurs",
      enableTwoFa: "Activer la 2FA",
      seeAgainKey: "Revoir la clé / QR",
      atNextCOnnection: "Vous serez invité à saisir ce code lors de votre prochaine connexion",
      saveRecoveryCodes: "Conservez ces codes de récupération en lieu sûr. Ils vous permettront d'accéder à votre compte si vous perdez l'accès à votre application d'authentification.",
      openMyAuthApp: "Ouvrir mon application d'authentification",
      showQrCode: "Afficher le QR code",
      done: "OK",
      secureYourAccount: "Sécurisez votre compte",
      secureYouAccountDesc: "Activez la double authentification (2FA) pour ajouter un code à 6 chiffres à chaque connexion. Fortement recommandé.",
      deactivateSecureAccount: "Désactiver la double authentification (2FA) pour votre compte. Vous ne serez plus invité à saisir un code à 6 chiffres lors de vos connexions.",
      enableNow: "Activer maintenant",
      nextTime: "Plus tard",
      noMorePrompt: "Ne plus me le proposer",
    },

    register: {
      title: "Créer un compte",
      coach: "Entraîneur",
      school: "École",
      schoolName: "Nom de l'école",
      userInformations: "Information du dirigeant",
      coachInformations:"Information de l'entraîneur",
      connexionInformations: "Information de connexion",
      subtitle: "Remplissez vos informations pour commencer",
      hasAccount: "Vous avez déjà un compte ?",
      login: "Se connecter",
      terms: "En vous inscrivant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      joinToday: "Rejoignez-nous aujourd'hui",
      orSignUpWith: "Ou inscrivez-vous avec",
      continueWithApple: "Continuer avec Apple",
      continueWithGoogle: "Continuer avec Google",
      tokenValidationFailed: "La validation du jeton a échoué",
      tokenMissing: "Le jeton est manquant",
      invalidToken: "Jeton invalide",
      referralRegister: "Vous vous inscrivez via un lien de parrainage",
      student: {
        title: "Créer un compte élève",
        subtitle: "Remplissez les informations de l'étudiant",
        welcome: "Vous êtes invité à rejoindre l'école: {{schoolName}}",
        join_now: "Rejoindre maintenant",
      },
      teacher: {
        title: "Créer un compte Entraîneur",
        subtitle: "Remplissez les informations de l'entraîneur",
        welcome: "Vous êtes invité à rejoindre l'école: {{schoolName}}",
        join_now: "Rejoindre maintenant",
      },
      parent: {
        title: "Créer un compte Famille",
        subtitle: "Remplissez les informations du parent",
        welcome: "Vous êtes invité à rejoindre l'école: {{schoolName}}",
        join_now: "Rejoindre maintenant",
      },
      accountCreated: "Compte créé avec succès",
      success: "Félicitations!",
      registrationFailed: "Merci de choisir un autre identifiant de connexion.",
      joinCommunity: "Rejoignez notre communauté de coachs",
      createYourAccount: "Créez votre compte et commencez à profiter de ces avantages",
       "steps": {
        "benefits": {
          "1": "Planification intelligente qui vous fait gagner du temps",
          "2": "Gestion des clients et suivi des progrès",
          "3": "Traitement sécurisé des paiements",
          "4": "Applications mobiles pour iOS et Android",
          "5": "Analyse des données et statistiques commerciales",
          "6": "Assistance client disponible 24h/24 et 7j/7"
        }
      }
    },

    forgotPassword: {
      title: "Mot de passe oublié",
      username: "Identifiant de connexion",
      subtitle: "Entrez votre identifiant et nous vous enverrons un lien pour réinitialiser votre mot de passe",
      resetLink: "Envoyer le lien de réinitialisation",
      resetButton: "Réinitialiser le mot de passe",
      rememberPassword: "Vous vous souvenez de votre mot de passe ?",
      login: "Se connecter",
      checkEmail: "Vérifiez votre email",
      checkEmailDesc: "Si un compte existe pour {email}, nous avons envoyé un lien de réinitialisation du mot de passe.",
      emailSent: "Nous avons envoyé un lien de réinitialisation du mot de passe à votre adresse email.",
      sidebarTitle: "Retournez à votre plateforme de coaching",
      sidebarText: "Après avoir réinitialisé votre mot de passe, vous aurez accès à tous vos outils de coaching, données clients et fonctionnalités de planification.",
      errorTitle: "Erreur",
      errorGeneric: "Une erreur est survenue. Veuillez réessayer plus tard.",
      successTitle: "Email envoyé",
      successDescription: "Vérifiez votre boîte de réception pour le lien de réinitialisation du mot de passe.",
      error: "Merci de réessayer avec un autre identifiant de connexion",
      enterPassword: "Merci d'entrer votre nouveau mot de passe et sa confirmation pour votre compte",
      passwordsDoNotMatch: "Votre mot de passe et la confirmation doivent être identique",
      passwordTooShort: "Mot de passe trop court"
    },

    home: {
      download: {
        title: "Téléchargez l'application",
        subtitle: "Accédez à toutes les fonctionnalités depuis votre appareil mobile",
        ios: "Télécharger pour iOS",
        android: "Télécharger pour Android",
        simple: "Planification simple",
        simpleDesc: "Organisez facilement vos séances avec vos élèves",
        realTime: "Synchronisation",
        realTimeDesc: "Leçons auto synchronisées avec les plannings des élèves",
        securePayment: "Paiements sécurisés",
        securePaymentDesc: "Recevez les paiements directement via l'application",
        alwaysOnline: "Toujours accessible",
        alwaysOnlineDesc: "Travaillez depuis n'importe où, à tout moment"
      }
    },

    hero: {
      title: "Pilotez votre activité de coaching",
      subtitle: "La plateforme tout-en-un pour piloter votre activité de coaching avec performance et simplicité",
      cta: "Essayez gratuitement",
      sessionComplete: "Séance terminée",
      progressUpdated: "Progrès mis à jour",
      newBooking: "Nouvelle réservation",
      bookingTime: "Mardi à 14h"
    },

    features: {
      title: "Fonctionnalités puissantes pour les coachs",
      subtitle: "Tout ce dont vous avez besoin pour gérer votre entreprise de coaching en un seul endroit",
      smartScheduling: {
        title: "Planification intelligente",
        description: "Gérez efficacement votre calendrier avec des outils de planification automatisés"
      },
      studentManagement: {
        title: "Gestion des étudiants",
        description: "Créez / Importez / Invitez vos élèves pour une gestion et un suivi complet"
      },
      categoriesManagement: {
        title: "Gestion des catégories",
        description: "Organisez vos séances par catégories pour mieux suivre vos activités"
      },
      onlinePayments: {
        title: "Paiements en ligne",
        description: "Acceptez les paiements directement via la plateforme avec un traitement des paiements sécurisé"
      },
      studentAccounts: {
        title: "Comptes étudiants",
        description: "Donnez à vos étudiants accès à leur propre portail pour voir les plannings"
      },
      aiSummaries: {
        title: "Rapport de facture",
        description: "Rapport et exportation du rapport annuel de facturation"
      },
      schoolAccounts: {
        title: "Compte école",
        description: "Créez une structure regroupant plusieurs coachs, gérez votre équipe et pilotez votre établissement"
      },
      parentAccounts: {
        title: "Compte familles",
        description: "Donnez un accès groupé aux membres d'une même famille pour voir les plannings"
      },
       automaticInvoices: {
        title: "Facturation automatisée",
        description: "Générez automatiquement des factures selon votre planning, avec paiement intégré et rappels automatiques"
      }
    },

    pricing: {
      title: "Tarifs simples et transparents",
      subtitle: "Choisissez le plan qui convient le mieux à votre entreprise de coaching",
      monthly: "Mensuel",
      yearly: "Annuel",
      cta: "Commencer",
      popular: "Le plus populaire",
      login_required: "Connexion requise",
      login_to_continue: "Veuillez vous connecter ou créer un compte pour continuer votre abonnement",
      starter: {
        title: "Coach Sportif",
        price: "19",
        description: "Parfait pour les coachs individuels qui démarrent",
        features: [
          "Planification de base",
          "Notifications par email",
          "Suivi des paiements",
          "Accès à l'application mobile"
        ]
      },
      professional: {
        title: "Ecole de sport",
        price: "49",
        description: "Idéal pour les coachs établis avec une base de clients en croissance",
        features: [
          "Planification avancée",
          "Notifications par SMS",
          "Paiements en ligne",
          "Personnalisation de la marque",
          "Accès au portail étudiant",
          "Support prioritaire"
        ]
      },
      premium: {
        title: "Premium",
        price: "49",
        description: "Great for established coaches with a growing client base",
        features: [
          "Advanced scheduling",
          "SMS notifications",
          "Online payments",
          "Custom branding",
          "Student portal access",
          "Priority support"
        ]
      },
      elite: {
        title: "Élite",
        price: "99",
        description: "Pour les entreprises de coaching avec plusieurs coachs et un volume élevé",
        features: [
          "Nombre illimité d'étudiants",
          "Comptes multiples pour les coachs",
          "Analyses avancées",
          "Solution en marque blanche",
          "Accès à l'API",
          "Gestionnaire de compte dédié",
          "Intégrations personnalisées"
        ]
      }
    },

    agenda: {
      title: "Agenda",
      today: "Aujourd'hui",
      month: "Mois",
      view:"vue",
      week: "Semaine",
      day: "Jour",
      list: "Liste",
      edit: "Modifier",
      teacher: "Entraîneur",
      selectTeacher: "Séléctionnez un entraîneur",
      createInvoice: "Créer une facture",
      createStudentInvoice: "Facturer un élève",
      newEvent: "Nouvel événement",
      editEvent: "Modifier l'événement",
      deleteEvent: "Supprimer",
      eventName: "Nom de l'événement",
      startDate: "Date de début",
      endDate: "Date de fin",
      location: "Lieu",
      currency: "Devise",
      description: "Description",
      repeat: "Répéter",
      reminder: "Rappel",
      students: "Élèves",
      student: "Élève",
      noEvents: "Aucun événement trouvé",
      charges: "Frais",
      extraCharges: "Frais supplémentaires",
      noEventsDescription: "Il n'y a pas d'événements programmés pour cette période",
      addYourFirst: "Ajoutez votre premier événement",
      upcoming: "Événements à venir",
      past: "Terminé",
      allDay: "Toute la journée",
      allDayWeek: "Jour entier",
      frequency: "Fréquence",
      until: "Jusqu'à",
      once: "Une fois",
      daily: "Quotidien",
      weekly: "Hebdomadaire",
      monthly: "Mensuel",
      biweekly: "Bimensuel",
      quarterly: "Trimestriel",
      yearly: "Annuel",
      category: "Catégorie",
      categories: "Catégories",
      addCategory: "Ajouter une catégorie",
      addLocation: "Ajouter un lieu",
      categoryName: "Nom de la catégorie",
      categoryColor: "Couleur de la catégorie",
      locationName: "Nom du lieu",
      locationAddress: "Adresse du lieu",
      notes: "Notes",
      status: "Statut",
      confirmed: "Confirmé",
      tentative: "Provisoire",
      cancelled: "Annulé",
      filter: "Filtrer",
      clearFilters: "Effacer les filtres",
      search: "Rechercher des événements",
      export: "Exporter",
      import: "Importer",
      print: "Imprimer",
      save: "Enregistrer l'événement",
      cancel: "Annuler",
      delete: "Supprimer l'événement",
      confirmDeletion: "Supprimer  l'événement",
      confirmDelete: "Confirmer la suppression",
      deleteAllRecurrence: "Souhaitez-vous également supprimer toutes les récurrences à venir",
      eventSaved: "Événement enregistré avec succès",
      eventDeleted: "Événement supprimé avec succès",
      eventCreated: "Événement créé avec succès",
      calendar: "Calendrier",
      noTeacherFound: "Aucun professeur trouvé",
      timeline: "Chronologie",
      newLesson: "Créer nouveau",
      scheduleLessonTitle: "Planifier un cours",
      scheduleLessonDesc: "Créez une nouvelle leçon avec vos élèves",
      selectCategory: "Sélectionner une catégorie",
      selectLocation: "Sélectionner un lieu",
      optional: "optionnel",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      date: "Date",
      dateRangeHint: "Sélectionner une plage de dates",
      priceCalculation: "Calcul du prix",
      duration: "Durée",
      numberOfStudents: "Nombre d'étudiants",
      createNewLesson: "Créer un nouveau cours",
      totalPrice: "Prix total",
      paymentType: "Type de paiement",
      createEvent: "Créer un événement",
      eventType: "Type d'événement",
      specialEvent: "Événement",
      studentAbsence: "Elève absent",
      coachAbsence: "Professeur absent",
      minutes: "Minutes",
      fixedPrice: "Prix fixe",
      hourly_rate: "Tarif horaire",
      pickDate: "Choisir une date",
      isRecurring: "Ceci est un événement récurrent",
      recurrenceEndDate: "Date de fin de récurrence",
      note: "Note",
      notesPlaceholder: "Ajoutez des notes ou des détails sur ce cours...",
      createLesson: "Enregistrer",
      addNew: "Ajouter nouveau",
      eventsInView: "événements trouvés",
      viewType: "Type de vue",
      markCompleted: "Marquer comme terminé",
      deleteEvents: "Supprimer des cours",
      timeAndDate: "Calendrier",
      myAgenda: "Agenda",
      actions: "Gérer les cours",
      pastEvents: "Événements passés",
      futureEvents: "Événements à venir",
      selectAll: "Sélectionner tout",
      deselectAll: "Désélectionner tout",
      markCompletedTitle: "Sélectionner les événements à compléter",
      markCompletedDesc: "Marquer ces événements comme terminés",
      deleteEventsTitle: "Sélectionner les événements à supprimer",
      deleteEventsDesc: "Sélectionnez les événements que vous souhaitez supprimer",
      calendarSettings: "Paramètres du calendrier",
      timezone: "Changer de fuseau horaire",
      showWeekends: "Afficher les week-ends",
      hideSidebar: "Mode plein écran",
      showSidebar: "Quitter le mode plein écran",
      todaysLessons: "Aujourd'hui",
      currentTime: "Heure actuelle",
      timezoneChanged: "Fuseau horaire modifié",
      calendarNowUsing: "Le calendrier utilise maintenant",
      weekendsShown: "Week-ends affichés",
      weekendsHidden: "Week-ends masqués",
      resetCalendar: "Réinitialiser le calendrier",
      settings: "Paramètres",
      selectTimezone: "Sélectionner le fuseau horaire",
      apply: "Appliquer",
      noLessonsToday: "Aucun cours prévu pour aujourd'hui",
      noPastEvents: "Aucun événement passé",
      noFutureEvents: "Aucun événement à venir",
      noUncompletedPastEvents: "Aucun événement passé non terminé",
      noUncompletedFutureEvents: "Aucun événement à venir non terminé",
      selectStudents: "Sélectionner les étudiants",
      selectTeachers: "Séléctionner les professeurs",
      teachers: "Professeurs",
      searchStudent: "Rechercher",
      noStudentFound: "Aucun étudiant trouvé",
      remove: "Retirer",
      manageLessons: "Actions",
      exportLessons: "Exporter les cours",
      exportDescription: "Exporter vos cours de la vue actuelle dans le format de votre choix",
      printableDocument: "Document imprimable",
      spreadsheetFormat: "Format de tableur",
      developerFriendly: "Pour les développeurs",
      eventsExportedSuccessfully: "Cours exportés avec succès",
      markAsCompleted: "Tout valider",
      markEventAsCompleted: "Valider",
      addExtraExpenses: "Frais supplémentaires",
      moreOptions: "Plus d'options",
      recurring: "Activer la récurrence",
      invoiceTypeS: "Facture école",
      invoiceTypeT: "Facture professeur",
      recurrenceType: "Type de récurrence",
      every7Days: "Chaque jour (Lundi au Lundi)",
      every14Days: "Chaque jour (Lundi au Vendredi)",
      every30Days: "Chaque jour (Lundi au Samedi)",
      everyWeek: "Chaque semaine",
      hourlyRate: "Prix par heure",
      selectEventsToMarkAsCompleted: "Selectionnez les élèments à valider",
      selectEventsToDelete: "Selectionnez les élèments à supprimer",
      lessons: "Lessons",
      events: "Evènements",
      all: "Tous",
      filterBy: "Filtrer par",
      noEventsFound: "Aucun évènement trouvé",
      firstDayOfWeek:"1er jour de la semaine",
      dayStartTime: "Heure de début",
      dayEndTime: "Heure de fin",
      monday: "Lundi",
      sunday: "Dimanche",
      eventTextColor: "Couleur du texte",
      light: "Clair",
      dark: "Sombre",
      filters: "Filtres",
      filterCategories: "Filtrer par catégorie",
      filterStudents: "Filtrer par élève",
      filterLocations: "Filtrer par localisation",
      searchStudents: "Chercher un élève",
      activeFilters: "Filtres actifs",
      hidden: "(caché)",
      exportEvents: "Exporter l'agenda",
      exportEventsDescription: "Choisissez un format pour exporter votre vue actuelle",
      exportNow: "Exporter maintenant",
      noStudents: "Aucun élève trouvé",
      noCategories: "Aucune catégorie trouvée",
      noLocations: "Aucune localisation trouvée",
      viewMonth: "Vue Mois",
      viewYear: "Vue Année",
      viewWeek: "Vue Sem.",
      viewDay: "Vue  Jour",
      viewList: "Vue Liste",
      newLessonAdded: "Nouveau cours ajouté",
      copy: "Copier",
      copyAll: "Copier tout",
      pasteNow: "Coller ici",
      copyEvents: "Copier les événements",
      pasteEvents: "Coller les événements",
      pasteEventsConfirmation: "Voulez-vous vraiment coller les événements ?",
      targetTimeframe: "Période cible",
      sourceTimeframe: "Période source",
      willPaste: "Vous allez coller ",
      confirmPaste: "Confirmer le collage",
      changeViewToPaste: "Changer la vue pour coller",
      eventsCopied: "Événements copiés",
      event: "Événement",
      pasteError: "Erreur de collage",
      lessonCreated: "Leçon créée",
      adjustDuration: "Ajuster la durée",
      settingRequired: "Aucun élève séléctionné.",
      showFullWeek: "Afficher toute la semaine",
      showFromToday: "A partir d'aujourd'hui",
      showUpcomingYear: "Voir toute l'année à venir",
      loadMore: "Charger les évènements suivants",
      viewListYear: "Liste Année",
      showCurrentWeek: "Revenir à la semaine",
      currentYear: "Année en cours",
      createBySchool: "Créé par l'école",
      eventForOtherCoach: "Appartient à un autre coach",
      eventMultiTeachers: "Plusieurs professeurs",
      addExtraForm: {
        title: "Gérez les frais supplémentaires",
        subTitle: "Joignez vos tickets de caisse",
        schoolFees: "Frais de l'école",
        teacherFees: "Frais du professeur",
        description: "Description des frais supplémentaires",
        amount: "Montant des frais supplémentaires",
        add: "Ajouter des frais supplémentaires",
        noExtraFees: "Aucun frais supplémentaire ajouté",
        takePhotoOrUpload: "Prendre une photo ou télécharger un reçu",
        preFilled: "pré-rempli",
        receipt: "Reçu",
      },
      createNew: {
        title: "Titre",
        titlePlaceholder: "Ajouter un titre",
        noteInfo: "Le détail des frais supplémentaires indiqués ici figurera sur la facture.",
        price: "Prix",
        extra: "Frais",
        extra_per_student: "Frais par élève",
        extraStudentOnly: "Ces frais supplémentaires seront facturés à chaque élève et versés à chaque enseignant.",
      },
      createFirstCategory: "Créer votre première catégorie",
      createFirstLocation: "Créer votre première localisation",
      createFirstStudent: "Créer votre premier élève",
      completed: "Validé",
      confirmUnlock: "Confirmer le déverrouillage",
      unlock: "Merci de confirmer le déverrouillage",
      unlockButton: "Déverrouiller",
      pleaseSelectDate: "Veuillez sélectionner une date",
      pleaseSelectRequiredFields: "Veuillez sélectionner tous les champs obligatoires",
      endDateCannotBeBeforeStartDate: "La date de fin ne peut être antérieure à la date de début",
      pleaseSelectRecurrenceEndDate: "Veuillez sélectionner la date de fin de récurrence",
      pleaseTryAgain: "Veuillez réessayer",
      missingInformation: "Informations manquantes",
      markAsAbsent: "Marquer comme absent",
      markAsPresent: "Marquer comme présent",
      statut: "Statut",
      absent: "Absent",
      present: "Présent",
      saveAllRecurrence: "Enregistrer toutes les récurrences",
      schoolCategories: "Catégories de l'école",
      teacherCategories: "Catégories de l'entraîneur",
      teacherRequired: "Vous devez choisir un entraîneur.",
      categoryRequired: "Vous devez choisir une catégorie",
      studentRequired: "Vous devez choisir au moins 1 élève",
      validationError: "Champs obligatoires",
      pendingSetting: "Paramètrez ce cours",
      invoiceType: "Type de facturation",
      selectTeacherFirst: "Choisissez un entraîneur",
      newEventAdded: "Evènement créé",
      saveAndContinue: "Enregistrer et créer un nouveau",
      privateLesson: "Privé",
      Lesson: "Leçon",
      Event: "Evènement",
      unknownType: "Type d'événement inconnu",
      categoryChoosenByTeacher: "Facture enseignant : l'enseignant choisit la catégorie",
      schoolCategory: "Catégorie d'école : l'école choisit la catégorie",
      schoolForCoachCategory: "Facturation professeur: l'école peut choisir la catégorie mais le professeur peut la modifier",
      searchFilters: "Rechercher des élèves",
      eventNotConfigured: "(Autre)",
      clearAll: "Réinitialiser",
      locations: "Lieux",
      schools: "Écoles",
      showCompletedEvents: "Afficher les cours terminés",
      categoryAdded: "Categorie ajoutée",
      addedToCategoriesList: "ajouté à la liste des catégories",
      noSelectedCategory: "Aucune catégorie séléctionnée",
      selectCategoryFirst: "Vous devez attribuer une catégorie à cette leçon pour continuer",
    studentOff: {
      title: 'Absence',
      description: 'Utilisez ce formulaire pour signaler votre absence. Votre coach sera automatiquement informé.',
      titleLabel: 'Titre de l’absence',
      titlePlaceholder: 'Ex: Absence maladie, Voyage...',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      chooseDate: 'Choisir une date',
      oneDayAbsence: 'Absence d’une journée',
      dateRange: 'Du {{start}} au {{end}}',
      noteLabel: 'Motif / Notes (optionnel)',
      notePlaceholder: 'Précisez le motif de votre absence si nécessaire...',
      cancel: 'Annuler',
      reportAbsence: 'Signaler l’absence',
      sending: 'Envoi en cours...',
      selectChildren: "Séléctionnez un membre de la famille",
      selectedChildren: "membre(s) séléctionné(s)"
    },
    invalidDateRange: 'Plage de dates invalide',
    absenceReported: 'Absence signalée',
    absenceSuccessfullyRecorded: 'Votre absence a été enregistrée avec succès.',
    errorCreatingAbsence: 'Échec de la création de l’absence',
    error: 'Erreur',
    unknownError: 'Une erreur est survenue, veuillez réessayer.',
    alreadyInvoiced: "Déjà facturé",
    allInvoiced: "Tous facturés",
    pleaseUnlockBeforeMove: "Veuillez déverrouiller cet événement avant de le déplacer",
    pleaseUnlockBeforeResize: "Veuillez déverrouiller cet événement avant de redimensionner",
    inProgress: "En cours",
    isCompleted: "Terminé",
    hours: "heures"
    },

    invoices: {
      title: "Factures",
      events: "lessons",
      noInvoices: "Aucune facture trouvée",
      noPendingBillings: "Aucune facture en attente",
      search: "Chercher une facture",
      billingStudents: "Facturation Élève",
      billingTeachers: "Facturation Professeur",
      currency: "Devise",
      billingPeriod: "Période de facturation",
      createNew: "Créer une facture manuelle",
      pendingBillings: "Facturations en attente",
      pendingBillingsDescription: "Choisissez un élève à facturer",
      pendingValidation: "Cours terminés à valider",
      pendingValidationDescription: "Événements non validés à valider avant facturation",
      pendingValidationBannerTitle: "Cours terminés en attente de validation",
      pendingValidationBannerDescription: "Vous avez {{count}} cours(s) terminé(s) à valider avant de pouvoir les facturer.",
      pendingValidationEventSingular: "cours à valider",
      pendingValidationEventPlural: "cours à valider",
      validate: "Valider",
      validateSelected: "Valider la sélection",
      validateAll: "Tout valider",
      eventsValidated: "Événements validés",
      eventsValidatedDescription: "Les événements sélectionnés ont été validés avec succès.",
      noPendingValidationEvents: "Aucun événement en attente de validation",
      selectAll: "Tout sélectionner",
      selectEvent: "Sélectionner l'événement",
      results: "résultat(s)",
      student: "Élève",
      teacher: "Professeur",
      studentInvoices: "Factures des élèves",
      teacherInvoices: "Factures professeur",
      pendingEvents: "En attente de facturation",
      selectEventsToInvoice: "Séléctionnez les leçons à facturer",
      lastEventDate: "Date du dernier événement",
      estimatedAmount: "Montant estimé",
      createInvoice: "Créer une facture",
      parameters: "Facture de l'élève",
      teacherParameters: "Facture du professeur",
      filters: "Filtres",
      date: "Date",
      category: "Categorie",
      recurringInvoices: "Factures récurrentes",
      duration: "Durée",
      amount: "Montant",
      extraCharges: "Frais",
      invoiceNumber: "Numéro de facture",
      invoiceDate: "Date de la facture",
      billingPeriodDateTooltip: "La période de facturation sera utilisée dans le rapport annuel de facturation",
      dueDate: "Date d'échéance",
      issueDate: "Date d'émission",
      notes: "Notes",
      taxes: "Taxes",
      discount: "Remise",
      noDiscount: "Pas de remise",
      percentageDiscount: "Remise en pourcentage",
      amountDiscount: "Remise en montant",
      discountScope: "Appliquer sur",
      discountScopeAll: "Tous les cours et événements",
      discountScopeLessons: "Seulement les cours",
      discountScopeEvents: "Seulement les événements",
      summary: "Résumé",
      subtotal: "Sous-total",
      tax: "Taxe",
      total: "Total",
      newInvoice: "Nouvelle facture manuelle",
      addItemsToInvoice: "Ajoutez des éléments à la facture",
      noItemsAdded: "Aucun élément ajouté",
      newInvoiceDescription: "Créez une facture pour un étudiant, veuillez choisir un étudiant et ajouter des éléments à la facture avec une date, une description et un montant.",
      selectStudent: "Sélectionner un ou plusieurs élèves",
      recurrentInvoice: "Facture récurrente",
      recurrentInvoiceDescription: "Cette facture sera automatiquement recréée selon la fréquence choisie jusqu'à la date de fin de récurrence",
      recurrentDateRequired: "Date de récurrence requise",
      pleaseSelectStudent: "Veuillez sélectionner au moins un élève",
      pleaseAddItems: "Veuillez ajouter au moins un élément à la facture",
      noStudentSelected: "Aucun élève sélectionné",
      recurrentDate: "Date de la récurrence",
      nextInvoiceDate: "Prochaine date de facture",
      recurrenceFrequency: "Fréquence de récurrence",
      recurrenceEndDate: "Date de fin de récurrence",
      items: "Éléments",
      selected: "élève(s) sélectionné(s)",
      addItem: "Ajouter un élément",
      description: "Description",
      feeDescriptionPlaceholder: "Titre des frais",
      addFee: "Ajouter des frais",
      additionalFees: "Frais supplémentaires",
      feeDescription: "Description des frais",
      create: "Créer",
      noTaxes: "Aucune taxe",
      invoiceSent: "Facture envoyée",
      invoiceSentDescription: "Description de la facture envoyée",
      invoiceNotSent: "Facture non envoyée",
      invoiceNotSentDescription: "Description de la facture non envoyée",
      itemValidationError: "Erreur de validation de l'élément",
      notesPlaceholder: "Ajouter une note",
      descriptionPlaceholder: "Titre de l'élément",
      filterDescription: "Description du filtre",
      filterByCategory: "Filtrer par catégorie",
      filterByPeriod: "Filtrer par période",
      allCategories: "Toutes les catégories",
      allTime: "Tout le temps",
      currentMonth: "Mois en cours",
      currentYear: "Année en cours",
      customDateRange: "Plage de dates personnalisée",
      dateRange: "Période",
      pickDateRange: "Séléctionnez une période",
      noResultsFound: "Aucun résultat trouvé",
      send: "Envoyer",
      resend: "Renvoyer",
      invoiceWillBeSentWithOverdue: "La facture sera envoyée avec le statut \"En retard\"",
      sended: "Envoyé le",
      deleted: "Supprimé",
      noEmailsAvailable: "Aucun email disponible pour cet élève",
      createSenderEmail: "Enregistrer comme adresse par défaut de l'étudiant",
      expenses: "Frais",
      report: "Report",
      downloading: "Téléchargement...",
      registeredPaymentMethods: "Autres méthodes de paiement",
      editInvoice: "Modifier la facture",
      noPendingEvents: "Aucune lesson à facturer",
      invoiceUpdated: "Facture mise à jour",
      invoiceUpdatedDescription: "La facture a bien été mise à jour",
      recurringValid: "Récurrence valide",
      recurringInvalid: "Récurrence terminée",
      invoiceCreated: "Création de la facture",
      lastInvoiceDate: "Date de la dernière facture",
      invoiceCreatedDescription: "La facture a bien été créée",
      recurrenceStopped: "Récurrence terminée",
      recurrenceStoppedDescription: "La facture récurrente a bien été stoppée",
      recurringInProgress: "En cours",
      recurringStopped: "Terminées",
      recurringFrequencyList: {
        daily: "Quotidienne",
        weekly: "Hebdomadaire",
        biweekly: "Bimensuelle",
        monthly: "Mensuelle",
        quarterly: "Trimestrielle",
        yearly: "Annuelle"
      },
      filter:{
        status: "Statut",
        type: "Type",
        date: "Date",
        selectDate: "Sélectionner une date",
        allStudents: "Tous les élèves",
        allTeachers: "Tous les professeurs",
        allStatuses: "Tous les statuts",
        allTypes: "Tous les types",
        resetFilters: "Réinitialiser les filtres",
        year: "Année",
        allYears: "Toutes les années",
      },
      type: {
        automatic: "Factures",
        manual: "Factures manuelles",
        shop: "Factures de la boutique"
      },
      status: {
        paid: "Payé",
        paid_cash: "Payé (cash)",
        paid_card: "Payé (carte)",
        pending: "En attente",
        overdue: "En retard"
      },
      columns: {
        invoice: "N°",
        student: "Élève",
        date: "Date",
        amount: "Montant",
        status: "Statut",
        type: "Type",
        send: "Envoyer",
        client: "Client"
      },
      settings: {
        account: "N° de Compte",
        bankName: "Nom de la banque",
        bankAddress: "Adresse",
        notes: "Notes",
        bankUser: "Titulaire du compte",
        personalInfo: "Informations personnelles",
        paymentInfo: "Informations de paiement",
        brandingInfo: "Informations de marque",
        addressInfo: "Informations d'adresse",
        logo: "Enregistrez vos informations de marque qui seront affichées sur vos factures",
        uploadLogo: "Sélectionner un fichier image",
        logoHint: "(png;jpg;jpeg) | max. 5 Mo",
        companyName: "Nom de l'entreprise",
        address: "Adresse",
        city: "Ville",
        street: "Rue",
        streetNumber: "Numéro de rue",
        zipCode: "Code postal",
        country: "Pays",
        phone: "Téléphone",
        email: "Email",
        vatNumber: "Numéro de TVA",
        iban:  "IBAN",
        bic: "BIC",
        preferencesInfo: "Préférences",
        dueDatePreference: "Date d'échéance",
        validateDatePreference: "Date de validation",
        displayStudentCount: "Afficher le nombre d'élèves sur la facture",
        otherPreferences: "Autres préférences",
        dueDateHint: "Choisissez la date d'échéance par défaut pour les factures",
        invoice_setting_description: "Personnalisez vos paramètres de facturation ",
        updateSuccess: "Paramètres mis à jour avec succès",
        preference1: "Préférence 1",
        preference2: "Préférence 2",
        preference3: "Préférence 3",
        preference4: "Préférence 4",
        addPaymentMethod: "Ajouter un moyen de paiement",
        currencyCodePreference: "Devises",
        registeredPaymentMethods: "Autres moyens de paiement",
        paymentMethods: {
          cash: "Espèces",
          bankTransfer: "Virement bancaire",
          creditCard: "Carte de crédit",
          paypal: "PayPal",
          stripe: "Carte de crédit (Stripe)",
          stripeSettingNow: "Configurer Stripe",
          venmo: "ID Venmo",
          venmoQRCode: "Code QR Venmo",
          QRCode: "Code QR",
          eTransfer: "Virement électronique",
          noAvailableMethods: "Aucun moyen de paiement disponible",
          paypal_description: "Description PayPal",
          stripe_description: "Description Stripe",
          bankTransfer_description: "Description Virement bancaire",
          creditCard_description: "Description Carte de crédit",
          selectPaymentMethod: "Sélectionner un moyen de paiement",
          paymentMethodAdded: "Moyen de paiement ajouté",
          stripeDescription: "Configurez votre compte connecté Stripe pour proposer à vos élèves de régler leur facture en ligne par carte bancaire",
          stripeSettingNotCompleted: "Configuration Stripe non terminée",
          changeStripeConfiguration: "Modifier mes informations"
        },
        dueDate: {
          immediate: "Immédiat",
          days7: "7 jours",
          days14: "14 jours",
          days30: "30 jours",
          days45: "45 jours",
          days60: "60 jours",
        },
        validateDate: {
          immediate: "Quand le cours est terminé",
          days1: "1 jour avant",
          days2: "2 jours avant",
          days3: "3 jours avant",
          days4: "4 jours avant",
          days5: "5 jours avant",
          days6: "6 jours avant",
          days7: "7 jours avant",
          days8: "8 jours avant",
          days9: "9 jours avant",
          days10: "10 jours avant",
          days11: "11 jours avant",
          days12: "12 jours avant",
          days13: "13 jours avant",
          days14: "14 jours avant",
        },
        tabs: {
          personal: "Personnel",
          payment: "Paiement",
          logo: "Logo",
          taxes: "Taxes",
          preferences: "Préférences",
        }
      },
      buttons: {
        create: "Créer la facture",
        update: "Modifier la facture",
      },
      actions: {
        title:"",
        view: "Voir",
        download: "Télécharger",
      },
      recurring: {
      title: "Factures récurrentes",
      description: "Gérez vos factures récurrentes",
      fetchErrorTitle: "Erreur de chargement des factures récurrentes",
      fetchErrorDescription: "Une erreur est survenue lors du chargement des factures récurrentes. Veuillez réessayer plus tard.",
      stopSuccessTitle: "Facture récurrente arrêtée",
      stopSuccessDescription: "La facture récurrente a été arrêtée avec succès.",
      stopErrorTitle: "Erreur lors de l’arrêt de la facture récurrente",
      stopErrorDescription: "Une erreur est survenue lors de l’arrêt de la facture récurrente. Veuillez réessayer plus tard.",
      date: "Date de la prochaine facture",
      nextDate: "Date de la prochaine facture",
      customer: "Client",
      amount: "Montant",
      status: "Statut",
      actions: "Actions",
      active: "Active",
      stopped: "Arrêtée",
      stop: "Arrêter",
      invoiceActions: "Actions",
      stopRecurrence: "Supprimer la récurrence",
      noInvoices: "Aucune facture récurrente trouvée",
    }
    },

    settings: {
      title: "Paramètres",
      subtitle: "Gérez les paramètres et les préférences de votre compte",
      cardTitle: "Paramètres",
      tabs: {
        students: "Étudiants",
        teachers: "Professeurs",
        categories: "Catégories",
        locations: "Lieux",
        invoices: "Factures",
        taxes: "Taxes",
        shop: "Boutique",
      },
      accountSettings: "Paramètres du compte",
      profileInformation: "Informations du profil",
      updatePassword: "Mettre à jour le mot de passe",
      generalSettings: "Paramètres généraux",
      language: "Langue",
      theme: "Thème",
      notifications: "Notifications",
      emailNotifications: "Notifications par email",
      pushNotifications: "Notifications push",
      privacy: "Confidentialité",
      dataSharing: "Préférences de partage des données",
      termsOfService: "Conditions d'utilisation",
      privacyPolicy: "Politique de confidentialité",
      logout: "Déconnexion"
    },

    dashboard: {
      welcome: "Bienvenue",
      totalRevenue: "Revenu total",
      lessonsScheduled: "Cours programmés",
      studentsEnrolled: "Étudiants inscrits",
      recentActivities: "Activités récentes",
      viewAll: "Voir tout"
    },

    navbar: {
      dashboard: "Tableau de bord",
      agenda: "Agenda",
      students: "Étudiants",
      settings: "Paramètres",
      logout: "Déconnexion"
    },

    auth: {
      login: "Se connecter",
      register: "S'inscrire",
      email: "Adresse email",
      password: "Mot de passe",
      name: "Nom",
      loginTitle: "Connexion",
      loginSubtitle: "Connectez-vous pour accéder à votre compte.",
      registerTitle: "Créer votre compte",
      registerSubtitle: "Inscrivez-vous pour commencer à utiliser notre application.",
      loggedIn: "Connecté",
      loggedOut: "Déconnecté",
      profile: "Profil"
    },

    students: {
      all: "Tous",
      schoolStudents: "École",
      coachStudents: "Professeur",
      noStudentAddedYet: "Aucun étudiant ajouté pour l'instant",
      notAllowed: "🚫 Elève du coach",
      notAllowedForAll: "🚫 Elève de l'école",
      myStudents: "Mes élèves",
      noStudentsAssociated: "Aucun élève associé à cette famille",
      startByAddingFirstStudent: "Commencez par ajouter votre premier élève",
      noMatchingStudentFound: "Aucun étudiant correspondant trouvé",
      perPage: "Résultats par page",
      contactStudent: "Envoyer un message",
      sendMessageTo: "Envoyez un message à {{studentName}}",
      familyDetails: "Détails de la famille",
      coachStudentsDesc: "Cet élève a été créé par un professeur",
      cochStudentDeleted: "Cet élève a été supprimé",
      search: "Rechercher un étudiant",
      familyMembers: "Membres de la famille",
      studentList: "Liste des étudiants",
      addStudent: "Ajouter un étudiant",
      addStudentTofamily: "Ajouter des élèves",
      addSelectedStudents: "Ajouter (sélectionnés)",
      confirmDeleteFamily: "Confirmer la suppression de la famille et de tous ses élèves associés ?",
      add: "Ajouter",
      editStudent: "Modifier un étudiant",
      studentDetails: "Détails de l'étudiant",
      name: "Nom",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      street: "Rue",
      streetNumber: "Numéro de rue",
      zipCode: "Code postal",
      place: "Ville",
      notes: "Notes",
      notesPlaceholder: "Toute information importante sur l'étudiant",
      addStudentTitle: "Ajouter un nouvel étudiant",
      addStudentDesc: "Remplissez le formulaire ci-dessous pour ajouter un nouvel étudiant.",
      editStudentTitle: "Modifier les détails de l'étudiant",
      editStudentDesc: "Modifiez les détails de l'étudiant ci-dessous.",
      selectStudents: "Sélectionner les étudiants",
      billingAddress: "Adresse de facturation",
      invoiceSettings: "Paramètres de facture",
      selectSection: "Sélectionnez une section",
      splitInvoicesBetweenParents: "Diviser les factures entre les deux parents",
      splitInvoicesBetweenParentsHelp: "Chaque facture pour cet élève sera divisée en deux, une pour chaque parent. Les coordonnées des parents sont obligatoires.",
      invoiceSplitNoticeTitle: "Cette facture sera divisée en deux",
      invoiceSplitNoticeDescription: "Dans le cas où le montant est impair, un écart de 0,01 € sera appliqué à la première facture pour équilibrer le total. Deux factures seront créées, une pour chaque parent.",
      parentInfoRequiredForSplit: "Les informations des deux parents doivent être complètes pour activer la division de la facture.",
      invoiceSplitParentInfoRequiredTitle: "Informations parentales requises",
      invoiceSplitParentInfoRequiredDescription: "Veuillez compléter le nom et l'e-mail des deux parents pour partager les factures.",
      splitCreatedTitle: "{{count}} factures créées",
      splitCreatedSubtitle: "La facturation a été répartie entre les parents. Que souhaitez-vous faire maintenant ?",
      splitCreatedBillAnother: "Facturer un autre élève",
      splitCreatedBillAnotherHelp: "Retourner à la liste de facturation",
      splitCreatedInvoicesTitle: "Factures créées",
      splitCreatedInvoice: "Facture {{index}}",
      splitCreatedRecipient: "Destinataire",
      splitCreatedStudent: "Élève",
      splitCreatedPeriod: "Période",
      splitCreatedDate: "Date",
      splitCreatedTotal: "Total",
      splitCreatedManage: "Gérer la facture",
      splitCreatedLoadError: "Impossible de charger le détail de cette facture.",
      splitCreatedPending: "En attente",
      selected: "Sélectionné",
      found: "élève trouvé",
      founds: "élèves trouvés",
      student: "Élève",
      students: "Élèves",
      families: "Familles",
      firstName: "Prénom",
      lastName: "Nom de famille",
      lastNamePlaceholder: "Entrez le nom de famille de l'élève",
      firstNamePlaceholder: "Entrez le prénom de l'élève",
      emailPlaceholder: "Entrez l'adresse e-mail de l'élève",
      phonePlaceholder: "Entrez le numéro de téléphone de l'élève",
      mobile: "Portable",
      mobilePlaceholder: "Entrez le numéro de portable de l'élève",
      parentInfo: "Informations des parents",
      motherEmail: "E-mail de la mère",
      motherEmailPlaceholder: "Entrez l'adresse e-mail de la mère",
      motherPhone: "Téléphone de la mère",
      motherPhonePlaceholder: "Entrez le numéro de téléphone de la mère",
      motherName: "Prénom/Nom de la mère",
      fatherName: "Prénom/Nom du père",
      fatherEmail: "E-mail du père",
      fatherEmailPlaceholder: "Entrez l'adresse e-mail du père",
      fatherPhone: "Téléphone du père",
      fatherPhonePlaceholder: "Entrez le numéro de téléphone du père",
      edit: "Modifier l'élève",
      loading_students: "Chargement des élèves",
      search_students: "Rechercher",
      add_student: "Ajouter un élève",
      optional: "Optionnel",
      studentAdded: "Élève ajouté avec succès",
      addedToStudentsList: "Élève ajouté à la liste des élèves",
      noAccount: "Aucun compte",
      registered: "Compte enregistré",
      sendInvite: "Inviter",
      inviteToCreateAccount: "Inviter à créer un compte",
      invitationSent: "Invitation envoyée",
      passwordLinkSent: "Lien de mot de passe envoyé",
      note: "Note",
      noFamilies: "Aucune famille trouvée",
      dissociateStudent: "Dissocier l'élève de la famille",
      search_families: "Rechercher",
      createFamily: "Créer une famille",
      createNewFamily: "Créer une nouvelle famille",
      family_name: "Nom de la famille",
      emailFamily: "Email de contact",
      noEmailForInvite: "Une adresse email est requise pour envoyer une invitation à l'élève",
      addFamily: "Ajouter une famille",
      confirmDelete: "Confirmer la suppression",
      confirmDeleteDesc: "Êtes-vous sûr de vouloir les {{count}} élèves séléctionnés ?",
      confirmDeleteStudent: "Êtes-vous sûr de vouloir supprimer",
      sendIdentifier: "Renvoyer les informations",
      personalInfo: "Infos personnelles",
      studentInvitationDesc: "Votre élève à reçu une invitation pour rejoindre votre établissement. En cliquant sur le lien dans le mail qu'il vient de recevoir, il pourra créer son compte et être automatiquement associé à votre établissement.",
      studentInvitationDesc2: "Votre élève peut également rejoindre votre établissement en entrant le code ci-dessous depuis son compte élève existant dans son profile dans la section \"Rejoindre\".",
      resendStudentAccountInformation: "Votre élève a déjà un compte avec le nom d'utilisateur",
      resendStudentAccountInformation2: "En renvoyant les informations de connexion à votre élève, il recevra un email contenant son nom d'utilisateur et un lien pour réinitialiser son mot de passe si besoin..",
      import: {
        title: "Importer des élèves",
        description: "Importez des élèves depuis un fichier CSV.",
        file: "Fichier CSV",
        import: "Importer",
        cancel: "Annuler",
        success: "Élèves importés avec succès",
        error: "Erreur lors de l'importation des élèves",
        no_file: "Aucun fichier sélectionné",
        selectedFile: "Fichier sélectionné",
        invalid_file: "Fichier non valide",
        empty_file: "Fichier vide",
      },
      duplicate: {
        title: "Doublons d'étudiants détectés",
        description: "Nous avons détecté {{duplicate}} doublon(s) entre vos étudiants personnels et ceux de l'école. Que souhaitez-vous faire pour chaque doublon ?",
        detectMode: "Doublon détecté par",
        coachStudent: "Votre élève",
        schoolStudent: "Élève de l'école",
        doNothing: "Ne rien faire",
        merge: "Garder mon élève",
        inviteAndMerge: "Inviter et garder mon élève",
        skip: "Ne rien faire",
        mergeInProgress: "Fusion en cours...",
        btnDetectDuplicate: "Doublons",
        selectStudentToMerge: "Sélectionnez un étudiant de l'école pour garder mon élève",
        confirmMerge: "Confirmer la fusion",
        areYouSurToMerge: "Êtes-vous sûr de vouloir garder mon élève",
        mergeExplication: "Vous conservez votre élève et vous mettez de côté celui de l'école",
        studentAlreadyHaveAccount: "Cet étudiant a déjà un compte dans votre espace coach",
        schoolMustInviteHim: "L'école doit les inviter à consulter leurs factures et leurs cours",
        studentleadyHaveAccountInSchool: "Cet étudiant a déjà un compte dans l'espace de l'école",
        youMustInviteHim: "Vous devez l'inviter à rejoindre votre espace",
        neitherHaveAccount: "Aucun étudiant n'a de compte",
      },
      msgStudentDeletedTitle: "Elève supprimé",
      msgConfirmDeletedStudent: "{{firstname}} {{lastname}} a été supprimé de votre liste d'élèves.",
      msgStudentAddedTitle: "Elève ajouté",
      msgStudentAdded: "{{firstname}} {{lastname}} a été ajouté à votre liste d'élèves.",
      msgStudentsAdded: "{{count}} élèves ont été ajoutés à votre liste d'élèves.",
    },

    teachers: {
      title: "Professeurs",
      teacher: "Professeur",
      teachers: "Professeurs",
      selected: "séléctionné",
      selecteds: "séléctionnées",
      searchPlaceholder: "Rechercher",
      search: "Rechercher un professeur",
      addTeacher: "Ajouter un enseignant",
      addTeacherDescription: "Ajouter un nouvel enseignant au système.",
      editTeacher: "Modifier l'enseignant",
      editTeacherDescription: "Modifier les détails de l'enseignant.",
      deleteTeacherConfirmTitle: "Supprimer l'enseignant",
      deleteTeacherConfirmDescription: "Êtes-vous sûr de vouloir supprimer cet enseignant?",
      name: "Nom",
      email: "Email",
      status: "Statut",
      active: "Actif",
      invited: "Invité",
      noSearchResults: "Aucun enseignant trouvé correspondant à votre recherche.",
      customizeTeacherColor: "Personnalisez la couleur d'affichage des événements de ce professeur",
      canViewOthers: "Le professeur peut consulter les cours et événements facturés par l'école à d'autres professeurs.",
      canViewTeacherInvoice: "Le professeur peut consulter les cours facturés par les enseignants et les événements des autres professeurs.",
      noTeachers: "Aucun enseignant disponible.",
      firstName: "Prénom",
      lastName: "Nom de famille",
      firstNamePlaceholder: "Entrez le prénom",
      lastNamePlaceholder: "Entrez le nom de famille",
      emailPlaceholder: "Entrez l'email",
      sendInvite: "Inviter",
      noAccount: "Aucun compte",
      invitationAt: "Invitation envoyée le",
      registered: "Enregistré",
      customizePrices: "Personnaliser les prix",
      customPricesFor: "Personnaliser les prix pour",
      useCustomPrices: "Utiliser des prix personnalisés",
      priceFix: "Prix fixe",
      moreThan20: "Plus que 20",
      inviteTeacherTitle: "Inviter un professeur",
      inviteTeacherDescription: "Envoyez une invitation pour permettre à ce professeur de créer un compte tout en rejoignant votre espace. En créant un compte depuis votre lien d'invitation, il pourra consulter restrospectivement les cours qui lui sont attribués et les factures qui lui sont destinées.",
      emailRequired: "Une adresse email est requise pour envoyer une invitation.",
      customSettings: "Paramètres",
      associatedTeachers: "Peut consulter l'emploi du temps des enseignants sélectionnés"
    },

    payment: {
      processing: "Paiement en cours...",
      invoice: "Facture",
      goto_account: "Accéder à votre compte",
      back_to_pricing: "Retour aux Tarifs",
      payment_details: "Détails de Paiement",
      complete_payment: "Payer maintenant",
      try_agai: "Réessayer",
      payment_successful: "Paiement Réussi",
      success_description: "Merci pour votre paiement. Votre abonnement a été activé.",
      payment_failed: "Paiement Échoué",
      failed_description: "Nous sommes désolés, mais votre paiement n'a pas pu être traité. Veuillez réessayer plus tard.",
      title: "Paiement de la facture",
      subtitle: "Payez votre professeur {{coach}} par carte bancaire",
      card_details: "Détails de la Carte",
      subscription: "Abonnement Premium",
      total: "Total",
      email: "Email",
      cardholder: "Nom du Titulaire de la Carte",
      billed_monthly: "Facturé Mensuellement",
      billed_annually: "Facturé Annuellement",
      annual_discount: "Remise annuelle",
      order_summary: "Récapitulatif de la Commande",
      pay: "Payer",
      card_number: "Numéro de Carte",
      expiry: "Date d'Expiration",
      cvv: "CVV",
      secure_encryption: "Vos informations de paiement sont sécurisées et cryptées.",
      infos: "En cliquant sur Payer maintenant, vous acceptez les conditions générales de ThePoppyApp.", 
    },
    
    subscription: {
      please_wait: "Veuillez patienter...",
      processing: "Traitement du paiement...",
      goto_account: "Aller au compte",
      back_to_pricing: "Retour aux tarifs",
      payment_details: "Détails du paiement",
      complete_payment: "Payer maintenant",
      try_again: "Réessayer",
      payment_successful: "Paiement réussi",
      success_description: "Merci pour votre paiement. Votre abonnement a été activé.",
      payment_failed: "Échec du paiement",
      failed_description: "Désolé, votre paiement n'a pas pu être traité. Veuillez réessayer plus tard.",
      title: "Informations de paiement",
      subtitle: "Entrez vos informations de paiement ci-dessous",
      card_details: "Informations de la carte",
      expiry_date: "Date d'expiration",
      cvc: "Code",
      subscription: "Abonnement au plan Premium",
      subscription_details: "Détails de l'abonnement",
      total: "Total",
      email: "E-mail",
      cardholder: "Nom du titulaire",
      billed_monthly: "Facturé mensuellement",
      billed_annually: "Facturé annuellement",
      annual_discount: "Remise annuelle",
      order_summary: "Récapitulatif de la commande",
      pay: "Payer",
      card_number: "Numéro de carte",
      expiry: "Date d'expiration",
      cvv: "CVV",
      secure_encryption: "Vos informations de paiement sont sécurisées et cryptées.",
      infos: "Votre abonnement sera automatiquement renouvelé chaque mois. Vous pouvez annuler votre abonnement à tout moment dans la section Mon abonnement de votre profil. En cliquant sur Payer maintenant, vous acceptez les Conditions générales.",
      error_title: "Erreur",
      retry: "Réessayer",
      success_title: "Succès",
      go_to_account: "Mon Compte",
      promo_code: "Code Promo",
      apply: "Appliquer",
      promo_code_applied: "Code promo appliqué !",
      invalid_promo_code: "Code promo invalide",
      subscription_successful: "Abonnement réussi",
      premiumAccess: "Accès Premium",
      addYourCouponCode: "Ajoutez votre code de réduction",
      discountWillBeApply: "La réduction sera automatiquement appliquée à votre prochaine facture après validation",
      enterCode: "Entrez le code",
      importantInfo: "Information importante",
      addCoupon: "Ajouter un coupon",
      discount_applied: "Remise appliquée",
      total_after_discount: "Total après remise",
      discount_once: "Remise (une fois)",
      discount_forever: "Remise (à vie)",
      discount_repeating: "Remise (pendant {{months}} mois)",
    },
    

    invoiceDetail: {
      date: "Date",
      subtitle: "Détails de la facture",
      download: "Télécharger",
      send: "Envoyer",
      invoice: "Facture",
      from: "De",
      to: "À",
      invoiceDate: "Date de la facture",
      dueDate: "Date d'échéance",
      description: "Description",
      quantity: "Durée",
      unitPrice: "Prix unitaire",
      total: "Total",
      subtotal: "Sous-total",
      tax: "Taxe",
      paymentMethod: "Méthode de paiement",
      paymentInstructions: "Instructions de paiement",
      cashPayment: "Paiement en espèce",
      thankyou: "Merci pour votre confiance !",
      vatNumber: "Numéro de TVA",
      pdfDownloaded: "PDF téléchargé avec succès !",
      selectRecipients: "Sélectionnez les destinataires",
      sendToRecipients: "Envoyer la facture",
      sendInvoice: "Envoyer",
      noEmailsSelected: "Aucun email séléctionné",
      pleaseSelectEmails: "Merci de choisir un email pour continuer",
      onlinePayment: "Paiement en ligne (via votre compte)",
      paypalPayment: "Paiement par PayPal",
      eTransferPayment: "Paiement par e-transfer",
      bankName: "Nom de la banque",
      bankAccount: "N° de compte",
      banIBAN: "IBAN",
      bankSwift: "SWIFT",
      bankUser: "Titulaire du compte",
      bankAddress: "Adresse",
      discount: "Remise",
      delete: "Supprimer",
      sentSuccess: "Facture envoyée avec succès !",
      sentSuccessDescription: "La facture a été envoyée avec succès à tous les destinataires sélectionnés.",
      noEmailsAvailable: "Aucun e-mail disponible pour cet élève",
      createSenderEmail: "Enregistrer comme adresse par défaut de l'étudiant",
      cannotDelete: "Vous ne pouvez pas supprimer cette facture.",
      cannotDeleteMessage: "La facture que vous essayez de supprimer est marquée comme payée. Vous ne pouvez supprimer que les factures qui n'ont pas encore été payées.",
      pay: "Payer maintenant",
      extra: "Frais",
      edit: "Modifier",
      shopPending: "La vérification de votre méthode de paiement peut prendre quelques secondes...",
      refresh: "Vérifier le statut",
      discountScopeLessons: "Remise sur les cours",
      discountScopeEvents: "Remise sur les événements",
    },

    validation: {
      required: "Obligatoire",
    },

    categories: {
      create_new: "Créer une nouvelle catégorie",
      loading_categories: "Chargement des catégories",
      search_categories: "Rechercher",
      edit: "Modifier la catégorie",
      name: "Nom de la catégorie",
      color: "Couleur sur l'agenda",
      paymentType: "Type de paiement",
      hourly_rate: "Tarif horaire",
      fixed_price: "Prix fixe",
      price_per_student: "Prix par élève",
      per_student: "Par étudiant",
      student: "Étudiant",
      students: "Étudiants",
      hourly: "par heure",
      more_than: "Plus de",
      confirmDelete: "Confirmer la suppression",
      confirmDeleteCategory: "Êtes-vous sûr de vouloir supprimer la catégorie",
      hourly_rate_explication: "Établissez un prix par élève, par heure, qui dépend du nombre d'élèves pendant le cours.",
      fixed_price_explication: "Établissez un prix par élève, par heure, qui soit le même quel que soit le nombre d'élèves pendant le cours.",
      hourlyRates: "Tarifs horaires",
      fixedPrices: "Prix fixes",
      noHourlyCategories: "Aucune catégorie avec tarif horaire",
      noFixedCategories: "Aucune catégorie avec prix fixe",
      additional_price: "Prix supplémentaire",
      tabStudents: "Prix étudiant",
      tabTeachers: "Prix professeur",
      price_per_teacher: "Prix par professeur",
      updated: "Catégorie mise à jour",
      hasBeenUpdated: "a été mis à jour",
      teacherPriceExplanation: "Voici le prix facturé par l'entraîneur à l'école pour cette catégorie.",
      StudentPriceExplanation: "Voici le prix facturé à l'étudiant pour cette catégorie."
    },

    locations: {
      locations: "Lieux",
      loading_locations: "Chargement des lieux",
      search_locations: "Rechercher",
      edit: "Modifier le lieu",
      school_location: "Lieu de l'école",
      name: "Nom du lieu",
      add_location: "Ajouter",
      create_new: "Ajouter un lieu",
      confirmDelete: "Confirmer la suppression",
      confirmDeleteLocation: "Êtes-vous sûr de vouloir supprimer le lieu"
    },

    taxes: {
      title: "Taxes",
      loading_taxes: "Chargement des taxes",
      search_taxes: "Rechercher",
      add: "Ajouter",
      update: "Mettre à jour",
      create_new: "Créer un nouveau",
      edit: "Modifier la taxe",
      confirmDelete: "Confirmer la suppression",
      confirmDeleteTaxe: "Êtes-vous sûr de vouloir supprimer la taxe",
      tax_name: "Nom de la taxe",
      percentage: "Pourcentage",
      tax_number: "N°/Réf. de taxe",
      amount: "Montant",
      optional: "Optionnel"
    },

    sessions: {
      sessions: "Sessions",
      sessions_subtitle: "Gérer les appareils sur lesquels vous êtes actuellement connectés",
      current: "Actuelle",
      last_active: "Dernière activité",
      logout: "Déconnecter",
      logoutAll: "Déconnecter de tous les appareils",
    },

    reports: {
      invoiceReport: "Rapport de factures",
      filterButton: "Appliquer le filtre",
      totalRevenue: "Revenu total",
      totalPaid: "Total payé",
      totalPending: "Total en attente",
      totalInvoices: "Total des factures",
      overview: "Aperçu",
      monthlyBreakdown: "Rapport mensuel",
      topStudents: "Meilleurs élèves",
      revenueOverview: "Aperçu des revenus",
      revenueDescription: "Répartition des revenus par mois",
      monthlyDescription: "Données mensuelles détaillées des factures",
      topStudentsDescription: "Élèves avec les dépenses les plus élevées",
      paymentMethods: "Méthodes de paiement",
      paymentMethodsDescription: "Répartition des paiements par méthode",
      month: "Mois",
      revenue: "Revenu",
      paid: "Payé",
      pending: "En attente",
      invoiceCount: "Factures",
      total: "Total",
      studentName: "Nom de l'élève",
      totalSpent: "Total dépensé",
      downloadReport: "Télécharger le rapport",
      saveReport: "Enregistrer le rapport",
      saving: "Enregistrement...",
      saveSuccess: "Rapport enregistré",
      saveSuccessDescription: "Le rapport a été enregistré avec succès",
      saveError: "Erreur d'enregistrement du rapport",
      saveErrorDescription: "Une erreur s'est produite lors de l'enregistrement du rapport",
      downloadStarted: "Téléchargement commencé",
      downloadStartedDescription: "Votre rapport est en cours de génération",
      exportReport: "Exporter le rapport",
      exportReportDescription: "Exporter votre rapport",
      exportNow: "Exporter maintenant",
      exportComplete: "Exportation terminée",
      exportCompleteDesc: "Votre rapport a été exporté avec succès",
      expenses: "Frais",
      taxes: "Taxes",
      beforeTax: "H.T",
      includingTax: "T.T.C",
      card: "Carte bancaire",
      cash: "Espèces",
      bankTransfer: "Virement bancaire",
      PayPal: "PayPal",
      Stripe: "Stripe",
      Venmo: "Venmo",
      ETransfer: "E-Transfer",
      months: {
        January: "Janvier",
        February: "Février",
        March: "Mars",
        April: "Avril",
        May: "Mai",
        June: "Juin",
        July: "Juillet",
        August: "Août",
        September: "Septembre",
        October: "Octobre",
        November: "Novembre",
        December: "Décembre"
      },
      paymentMethod: "Méthodes de paiement",
      totalAmount: "Total"
    },

     verify: {
      verifyAccount: "Vérification de votre compte",
      verifyAccountDesc: "Veuillez saisir le code de vérification qui vous a été envoyé",
      enterCode: "Entrez le code à 6 chiffres envoyé à votre e-mail",
      placeHolder: "Entrez le code de vérification",
      bntValidatingAccount: "Validation",
      btnSendingCode: "Envoi en cours",
      resendCode: "Renvoyer le code",
      bntVerifyAccount: "Vérifier le compte",
      doNotReceiveCode: "Je n'ai pas reçu de code ?",
      invalidCode: "Code de validation invalide. Veuillez réessayer.",
      accountValidated: "Compte vérifié",
      accountValidatedDesc: "Votre compte a bien été validé.",
      validationFailed: "Validation refusée",
      codeSent: "Code envoyé",
      codeSentDesc: "Un nouveau code de vérification à été envoyé à votre adresse email",
      resendFailed: "Code non envoyé",
      resendFailedDesc: "Envoi du code impossible pour le moment..."
    },

    date: {
      selectStartDate: "Sélectionner la date de début",
      selectEndDate: "Sélectionner la date de fin",
      selected: "Sélectionné",
    },

     maintenance: {
      title: "Page en maintenance",
      description: "Cette page est temporairement indisponible. Nous travaillons pour la remettre en ligne le plus rapidement possible",
      backToHome: "Retour à l'accueil"
    },

    invitations: {
      title: "Inviter à rejoindre votre école",
      description: "Partagez votre code d'invitation pour permettre aux utilisateurs de rejoindre votre école. Votre destinataire recevra un email avec les instructions pour accepter l'invitation en entrant le code depuis le profil de son compte. Si votre destinataire n'a pas encore de compte, il devra d'abord créer un compte puis entrer le code d'invitation pour rejoindre votre école.",
      coachEmail: "Email du destinataire",
      studentEmail: "Email de l'élève",
      sendInvitation: "Envoyer l'invitation",
      sentInvitations: "Invitations envoyées",
      sentInvitationDesc: "Liste des invitations récemment envoyées",
      noInvitationsSentYet: "Aucune invitation envoyée pour le moment",
      yourSchoolJoinCode: "Votre code d'invitation",
      yourSchoolJoinCodeDesc: "Partagez ce code pour permettre aux utilisateurs de rejoindre votre école depuis leur compte dans la section « Rejoindre » de leurs paramètres de profil.",
      sent: "Envoyé",
      joinSchool: "Rejoindre une nouvelle école",
      enterInvitationCode: "Entrez le code que vous avez reçu par email pour rejoindre votre nouvelle école",
      invitationCode: "Code d'invitation",
      joinSchoolBtn: "Rejoindre l'école",
      managerCoachInvitation: "Gérer les invitations des entraîneurs pour votre école",
      joinSchoolWithCode: "Rejoignez une école avec votre code d'invitation",
      pleaseEnterCode: "Merci d'entrer un code valide",
      invalidCode: "Code invalide",
      alreadyRegistered: "Vous êtes déjà enregistré dans cette école",
      placeholder: "Entrez le code d'invitation",
      toJoinDesc: "Rejoignez une école sportive et commencez votre aventure maintenant!",
      connectedSchool: "École Connectée",
      connectedSchoolDesc: "Vous êtes actuellement connecté à une école",
      connectedTeacherSchool: "Vous êtes professeur dans cette école",
      connectedStatusTeacherSchool: "Professeur Connecté",
      syncAgenda: "Agenda synchronisé",
      syncAgendaDesc: "Synchronisez votre planning avec l'école en temps réel",
      studentAccess: "Accès étudiants",
      studentAccessDesc: "Gérez les étudiants de l'école dans votre système",
      condifdentiality: "Confidentialité",
      condifdentialityDesc: "Vos paramètres et catégories restent privés",
      leaveInformation: "Pour rejoindre une autre école, vous devez d'abord vous dissocier de l'école actuelle",
      leaveSchool: "Quitter l'école",
      isLeaveSchool: "Quitter l'École ?",
      asLeaveSchoolDesc: "Êtes-vous sûr de vouloir vous dissocier de",
      consequences: "Conséquences",
      consequence1: "Perte de l'accès aux étudiants de l'école",
      consequence2: "Désynchronisation de l'agenda partagé",
      consequence3: "Retour au statut de coach indépendant",
      deconnectSchool: "Déconnexion",
      connexion: "Connexion en cours",
      congratulations: "Félicitations",
      welcomeToSchool: "Bienvenue dans l'école",
      yourNewSchool: "votre nouvelle école",
      successfullJoined: "Vous avez rejoint avec succès l'équipe. Votre aventure d'entraîneur commence maintenant",
      goToAgenda: "Voir l'Agenda",
      goToSettings: "Gérer les doublons",
      goToStudents: "Voir les étudiants",
      goToInvoices: "Voir les factures",

      noBackPossible: "Cette action est irréversible",
      leaveInformations: "Vous êtes sur le point de quitter",
      sharingSchedule: "Planning partagé",
      youLooseSharingSchedule: "Vous perdrez l'accès au planning partagé avec vos professeurs",
      studentList: "Liste d'étudiants",
      youLooseStudentList: "Vous n'apparaîtrez plus dans la liste des étudiants de l'école",
      forRejoinSchool: "Pour rejoindre à nouveau cette école, vous devrez demander une nouvelle invitation à votre professeur",
      confirmAndLeave: "Confirmer et quitter l'école",

      inviteStudent: "Inviter un élève",
      inviteStudentDesc: "Envoyer une invitation à un étudiant pour rejoindre votre école",
      sentInvitationStudentDesc: "Consultez vos invitations étudiantes envoyées"
    },


    referral: {
      title: "Parrainages",
      description: "Partagez votre lien d'invitation. Invitez un coach, gagnez un mois ! Votre prochain mois est offert pour chaque nouvel abonné parrainé",
      coachEmail: "Email de l'entraîneur",
      sendInvitation: "Mes parrainages",
      sentInvitations: "Bonus & Parrainage",
      sentInvitationDesc: "Liste de vos bonus obtenus",
      noInvitationsSentYet: "Aucun parrainage pour le moment",
      sent: "Rejoint",
      joinSchool: "Rejoindre l'école",
      enterInvitationCode: "Entrez votre code d'invitation pour rejoindre une école",
      invitationCode: "Code d'invitation",
      joinSchoolBtn: "Rejoindre l'école",
      managerCoachInvitation: "Gérer les invitations des entraîneurs pour votre école",
      joinSchoolWithCode: "Rejoindre une école avec votre code d'invitation",
      pleaseEnterCode: "Veuillez entrer un code d'invitation",
      invalidCode: "Code invalide",
      linkCopied: "Lien copié",
      linkCopiedSuccessfully: "Lien copié avec succès",
      yourInviteLink: "Votre lien d'invitation",
      copyLink: "Copier maintenant",
      notSubscribed: "Non abonné",
      subscribed: "Abonné",
      freeMonth: "1 Mois Gratuit",
    },

    notifications: {
      title: "Notifications",
      noNotifications: "Aucune notification pour le moment",
      notificationPreferences: "Préférences de notifications",
      notificationPreferencesSubtitle: "Gérez comment et quand nous vous contactons",
      emailNotifications: "Notifications par email",
      pushNotifications: "Notifications push",
      notificationsSettingsSaved: "Préférences de notifications enregistrées",
      notificationsSettingsSavedDesc: "Vos paramètres de notifications ont été mis à jour",
      savePreferences: "Enregistrer les préférences",
      list: [
        { 
          id: "email_new_bookings", 
          label: "Nouvelles réservations", 
          description: "Recevez un email lorsqu'une nouvelle leçon est réservée" 
        },
        { 
          id: "email_lesson_reminders", 
          label: "Rappels de leçons", 
          description: "Recevez un rappel pour vos leçons à venir" 
        },
        { 
          id: "email_schedule_changes", 
          label: "Changements d'emploi du temps", 
          description: "Soyez informé lorsqu'une leçon est reprogrammée ou annulée" 
        },
        { 
          id: "email_student_off", 
          label: "Absences des étudiants", 
          description: "Recevez une notification lorsqu'un étudiant annule ou est absent" 
        },
        { 
          id: "email_teacher_off", 
          label: "Absences des coachs", 
          description: "Recevez une notification lorsqu'un coach annule une leçon" 
        },
        { 
          id: "email_marketing_updates", 
          label: "Actualités et marketing", 
          description: "Nouvelles fonctionnalités et mises à jour de ThePoppyApp" 
        },
      ],
      pushList: [
        { 
          id: "push_new_bookings", 
          label: "Nouvelles réservations", 
          description: "Recevez une notification lorsqu'une nouvelle leçon est réservée" 
        },
        { 
          id: "push_lesson_reminders", 
          label: "Rappels de leçons", 
          description: "Recevez un rappel 1 heure avant vos leçons à venir" 
        },
        { 
          id: "push_schedule_changes", 
          label: "Changements d'emploi du temps", 
          description: "Soyez informé lorsqu'une leçon est reprogrammée ou annulée" 
        },
        { 
          id: "push_student_off", 
          label: "Absences des étudiants", 
          description: "Recevez une notification push lorsqu'un étudiant annule" 
        },
        { 
          id: "push_teacher_off", 
          label: "Absences des coachs", 
          description: "Recevez une notification push lorsqu'un coach annule" 
        },
      ],
    },


     pagination: {
      previous: "Précédent",
      next: "Suivant",
    },

    "legal": {
    "title": "Informations Juridiques",
    "subtitle": "Documents et politiques juridiques importants",
    "tabs": {
      "terms": "Conditions Générales d'Utilisation",
      "privacy": "Politique de Confidentialité",
      "cookies": "Politique des Cookies"
    },
    "terms": {
      "title": "Conditions Générales d'Utilisation",
      "lastUpdated": "Dernière mise à jour : 1 juin 2025",
      "sections": {
        "introduction": {
          "title": "1. Introduction",
          "content": "Bienvenue sur ThePoppyApp (\"nous\", \"notre\", ou \"nos services\"). En accédant ou en utilisant notre site web, nos applications mobiles, ou l'un de nos services, vous acceptez d'être lié par ces Conditions Générales d'Utilisation."
        },
        "accountRegistration": {
          "title": "2. Inscription du Compte",
          "content": "Pour utiliser certaines fonctionnalités de nos services, vous devrez peut-être vous inscrire pour un compte. Vous acceptez de fournir des informations exactes, actuelles et complètes lors du processus d'inscription et de mettre à jour ces informations pour les maintenir exactes, actuelles et complètes."
        },
        "subscriptionAndPayments": {
          "title": "3. Abonnement et Paiements",
          "content": "ThePoppyApp offre des services basés sur abonnement. En vous abonnant à nos services, vous acceptez de payer les frais applicables dès qu'ils deviennent dus. Les abonnements se renouvellent automatiquement jusqu'à ce qu'ils soient annulés."
        },
        "userContent": {
          "title": "4. Contenu de l'Utilisateur",
          "content": "Vous conservez la propriété de tout contenu que vous soumettez, publiez ou affichez sur ou via nos services (\"Contenu de l'Utilisateur\"). En soumettant du Contenu de l'Utilisateur, vous nous accordez une licence mondiale, non exclusive et libre de droits pour utiliser, copier, modifier et afficher votre Contenu de l'Utilisateur en lien avec les services."
        },
        "prohibitedActivities": {
          "title": "5. Activités Interdites",
          "content": "Vous acceptez de ne pas vous engager dans l'une des activités interdites suivantes : (i) copier, distribuer ou divulguer une partie de nos services ; (ii) utiliser un système automatisé pour accéder à nos services ; (iii) tenter d'interférer avec le bon fonctionnement de nos services."
        },
        "termination": {
          "title": "6. Résiliation",
          "content": "Nous pouvons résilier ou suspendre votre compte et l'accès à nos services à notre seule discrétion, sans préavis, pour des comportements que nous déterminons comme violant ces Conditions Générales d'Utilisation ou nuisibles à d'autres utilisateurs, à nous-mêmes, ou à des tiers, ou pour toute autre raison."
        },
        "disclaimerOfWarranties": {
          "title": "7. Exclusion de Garanties",
          "content": "Nos services sont fournis \"en l'état\" et \"selon disponibilité\" sans garanties de quelque nature que ce soit, expresse ou implicite."
        },
        "limitationOfLiability": {
          "title": "8. Limitation de Responsabilité",
          "content": "En aucun cas nous ne serons responsables des dommages indirects, spéciaux, accessoires, consécutifs, exemplaires ou punitifs."
        },
        "changesToTerms": {
          "title": "9. Modifications des Conditions",
          "content": "Nous pouvons modifier ces Conditions Générales d'Utilisation à tout moment. Votre utilisation continue de nos services après de telles modifications constitue votre acceptation des nouvelles conditions."
        },
        "governingLaw": {
          "title": "10. Loi Applicable",
          "content": "Ces Conditions Générales d'Utilisation seront régies et interprétées conformément aux lois des États-Unis, sans égard à ses dispositions de conflit de lois."
        }
      }
    },
    "privacy": {
      "title": "Politique de Confidentialité",
      "lastUpdated": "Dernière mise à jour : 1 juin 2025",
      "sections": {
        "informationWeCollect": {
          "title": "1. Informations que nous collectons",
          "content": "Nous collectons les informations que vous nous fournissez directement, par exemple lorsque vous créez un compte, mettez à jour votre profil, utilisez des fonctionnalités interactives, effectuez un achat ou nous contactez. Ces informations peuvent inclure votre nom, votre adresse e-mail, votre numéro de téléphone et vos informations de paiement."
        },
        "howWeUseYourInformation": {
          "title": "2. Comment nous utilisons vos informations",
          "content": "Nous utilisons les informations que nous collectons pour fournir, maintenir et améliorer nos services, pour traiter les transactions, pour vous envoyer des notifications techniques et des messages de support, pour communiquer avec vous à propos de produits, services et événements, et pour répondre à vos commentaires et questions."
        },
        "sharingOfInformation": {
          "title": "3. Partage des informations",
          "content": "Nous pouvons partager vos informations avec des prestataires de services qui effectuent des services en notre nom, tels que le traitement des paiements, l'analyse de données, la livraison d'e-mails et les services d'hébergement. Nous pouvons également partager des informations si la loi l'exige ou en lien avec une vente, une fusion ou une acquisition."
        },
        "security": {
          "title": "4. Sécurité",
          "content": "Nous prenons des mesures raisonnables pour aider à protéger vos informations personnelles contre la perte, le vol, l'utilisation abusive, l'accès non autorisé, la divulgation, l'altération et la destruction."
        },
        "yourChoices": {
          "title": "5. Vos choix",
          "content": "Vous pouvez accéder et mettre à jour certaines informations concernant votre compte en vous connectant à vos paramètres de compte. Vous pouvez également vous désinscrire de la réception d'e-mails promotionnels de notre part en suivant les instructions dans ces e-mails."
        },
        "cookies": {
          "title": "6. Cookies",
          "content": "Nous utilisons des cookies et des technologies similaires pour collecter des informations sur vos activités de navigation et pour vous distinguer des autres utilisateurs de nos services. Vous pouvez configurer votre navigateur pour refuser tous les cookies ou certains cookies, mais cela peut affecter votre capacité à utiliser nos services."
        },
        "internationalDataTransfers": {
          "title": "7. Transferts internationaux de données",
          "content": "Nous pouvons transférer vos informations personnelles vers des pays autres que celui dans lequel vous vivez. Nous nous appuyons sur des mécanismes légalement prévus pour transférer légalement les données à travers les frontières."
        },
        "childrensPrivacy": {
          "title": "8. Confidentialité des enfants",
          "content": "Nos services ne sont pas destinés aux enfants de moins de 13 ans, et nous ne collectons pas sciemment d'informations personnelles auprès d'enfants de moins de 13 ans."
        },
        "changesToThisPrivacyPolicy": {
          "title": "9. Modifications de cette Politique de Confidentialité",
          "content": "Nous pouvons modifier cette Politique de Confidentialité de temps à autre. Si nous apportons des modifications, nous vous en informerons en révisant la date en haut de la politique."
        },
        "contactUs": {
          "title": "10. Contactez-nous",
          "content": "Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter à contact@thepoppyapp.com."
        }
      }
    },
    "cookies": {
      "title": "Politique des Cookies",
      "lastUpdated": "Dernière mise à jour : 1 juin 2025",
      "sections": {
        "whatAreCookies": {
          "title": "1. Que sont les Cookies",
          "content": "Les cookies sont de petits morceaux de texte envoyés à votre navigateur web par un site web que vous visitez. Un fichier cookie est stocké dans votre navigateur web et permet à nos services ou à un tiers de vous reconnaître et de rendre votre prochaine visite plus facile et le service plus utile pour vous."
        },
        "howWeUseCookies": {
          "title": "2. Comment nous utilisons les Cookies",
          "content": "Nous utilisons les cookies aux fins suivantes : Authentification : Pour vous identifier lorsque vous vous connectez à nos services, Sécurité : Pour aider à protéger votre compte contre les accès non autorisés, Préférences : Pour mémoriser des informations sur la manière dont vous préférez que le service se comporte et apparaisse, Analytics : Pour nous aider à comprendre comment vous utilisez nos services, quelles fonctionnalités sont les plus populaires, et où nous pouvons faire des améliorations."
        },
        "typesOfCookiesWeUse": {
          "title": "3. Types de Cookies que nous utilisons",
          "content": "Nous utilisons à la fois des cookies de session et des cookies persistants. Les cookies de session sont temporaires et sont supprimés lorsque vous fermez votre navigateur. Les cookies persistants restent sur votre appareil jusqu'à ce qu'ils expire ou que vous les supprimiez."
        },
        "thirdPartyCookies": {
          "title": "4. Cookies de tiers",
          "content": "En plus de nos propres cookies, nous pouvons également utiliser divers cookies de tiers pour rapporter des statistiques d'utilisation, diffuser des publicités, etc."
        },
        "managingCookies": {
          "title": "5. Gestion des Cookies",
          "content": "La plupart des navigateurs web vous permettent de contrôler les cookies via leurs préférences de paramètres. Cependant, limiter la capacité des sites web à définir des cookies peut affecter votre expérience utilisateur globale. Si vous souhaitez supprimer les cookies ou configurer votre navigateur web pour supprimer ou refuser les cookies, veuillez visiter les pages d'aide de votre navigateur web."
        },
        "changesToThisCookiePolicy": {
          "title": "6. Modifications de cette Politique des Cookies",
          "content": "Nous pouvons mettre à jour notre Politique des Cookies de temps à autre. Nous vous informerons de toute modification en publiant la nouvelle Politique des Cookies sur cette page."
        }
      }
    }
  },
  
  shop: {
    title: "Boutique",
    subtitle: "Gérez vos articles de boutique",
    createProduct: "Créer un nouveau produit",
    editProduct: "Modifier le produit",
    createProductDescription: "Créez des carnets de coupons ou des tickets pour vos élèves",
    editProductDescription: "Modifier un produit existant",
    yourProducts: "Vos produits",
    yourProductsDescription: "Visualisez et gérez vos carnets de tickets et coupons",
    productTitle: "Titre",
    titlePlaceholder: "Entrez le titre du produit",
    description: "Description",
    descriptionPlaceholder: "Entrez la description du produit",
    quantity: "Quantité",
    selectQuantity: "Sélectionnez la quantité",
    tickets: "tickets",
    ticket: "ticket",
    price: "Prix",
    pricePerTicket: "Prix par ticket",
    priceHelp: "C'est le prix d'un seul ticket. Le prix total sera calculé automatiquement.",
    totalPrice: "Prix total",
    addProduct: "Ajouter le produit",
    noProducts: "Aucun produit pour l'instant",
    productCreated: "Produit créé",
    productCreatedDescription: "Votre produit a été créé avec succès",
    productUpdated: "Produit mis à jour",
    productUpdatedDescription: "Votre produit a été mis à jour avec succès",
    productDeleted: "Produit supprimé",
    productDeletedDescription: "Votre produit a été supprimé avec succès",
    confirmDelete: "Supprimer le produit",
    confirmDeleteDescription: "Êtes-vous sûr de vouloir supprimer ce produit ? Cette action ne peut pas être annulée.",
    fillAllFields: "Veuillez remplir tous les champs obligatoires",
    invalidPrice: "Veuillez entrer un prix valide",
    buyNow: "Acheter maintenant",
    shopNow: "Acheter",
    addToCart: "Ajouter au panier",
    viewShop: "Voir la boutique",
    Subtotal: "Sous-total",
    yourCoachHasNoProductsYet: "Votre coach n'a pas encore de produits pour la boutique",
    stripeConfigured: "Configuration de votre compte connecté",
    manageStripeAccount: "Gestion du compte connecté",
    shopNotEnable: "Configurez votre compte connecté pour activer votre boutique",
    showPayments: "Voir les paiements"
  },

  update: {
    browser: {
      title: "Mise à jour de navigateur requise",
      description: "Votre version de Safari n'est pas compatible avec cette application.",
      detected: "Navigateur détecté:",
      minimumVersion: "Version minimale requise pour Safari: 15.0",
      explanation: "Pour utiliser cette application, veuillez mettre à jour Safari vers la version 15.0 ou supérieure, ou utiliser un autre navigateur comme Chrome, Firefox ou Edge.",
      instruction: "Sur macOS, mettez à jour votre système d'exploitation pour obtenir les dernières versions de Safari. Sur iOS, mettez à jour vers la dernière version d'iOS.",
      goHome: "Retour à l'accueil",
      learnMore: "Comment mettre à jour Safari"
    }
  },

  contact: {
    title: "Contactez-nous",
    subtitle: "Nous sommes là pour vous aider.",
    description: "Envoyez-nous un message et nous vous répondrons dès que possible.",
    name: "Nom",
    email: "Email",
    subject: "Sujet",
    message: "Message",
    messagePlaceholder: "Votre message ici...",
    howWeCanHelp: "Comment pouvons-nous vous aider ?",
    sendMessage: "Envoyer le message",
    successTitle: "Message envoyé",
    successMessage: "Merci de nous avoir contactés ! Nous avons reçu votre message et nous vous répondrons sous peu.",
    errorTitle: "Erreur",
    errorMessage: "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer plus tard.",
    helpInfo: "Besoin d'aide ?",
    contactDetails: "Coordonnées",
    form: {
      name: "Nom",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer",
      thankYou: "Merci de nous avoir contactés !",
      success: "Votre message a été envoyé avec succès",
      error: "Veuillez remplir tous les champs obligatoires"
    },
    info: {
      title: "Contactez-nous",
      phone: "Téléphone",
      email: "contact @ thepoppyapp.com",
      help: "Posez votre question",
      ready: "Essayez gratuitement notre plateforme dès aujourd'hui !",
    },
    choiceSubject: {
      selectTopic: "Choisissez un sujet",
      enterTopic: "Entrez un sujet",
      accountIssues: "Problèmes de compte",
      billingPayments: "Facturation et paiements",
      featureRequests: "Demandes de fonctionnalités",
      technicalSUpport: "Assistance technique",
      other: "Autre",
    },
    closeContact: "Fermer cette discussion",
    closeContactDesc: "Cette action supprimera définitivement cette conversation avec l'assistance de ThePoppyApp",
    contactClosed: "Cette discussion est terminée",
    selectAConversation: "Séléctionnez une discussion",
    selectDesc: "Vous avez une conversation en cours. Veuillez la sélectionner dans la liste ou la fermer avant d'en démarrer une nouvelle"
  },

  bot:{
    typeYourMessage: "Posez votre question",
    send: "Envoyer"
  },

  wizard: {
    settings: "Cliquez sur Paramètres pour gérer vos catégories et autres réglages",
    categories: "Créez et organisez vos catégories de services. Ajoutez au moins une catégorie pour continuer", 
    categoriesTab: "C’est ici que vous pouvez créer et gérer vos catégories de services. Les catégories vous aident à organiser vos services et à définir des tarifs différents pour chaque type de service proposé.",
    students: "Ajoutez votre premier élève pour commencer à gérer votre activité de coaching plus efficacement",
    studentsTab: "C’est ici que vous pouvez ajouter et gérer vos élèves. Ajouter des élèves vous permet de suivre leurs informations, planifier des cours et gérer les paiements plus efficacement.",
    lessons: "Créez votre premier cours et commencez à utiliser la plateforme pour gérer votre activité de coaching plus efficacement",
    lessonsTab: "C’est ici que vous pouvez créer et gérer vos cours. Vous pouvez planifier des cours, les associer à des catégories et les lier à vos élèves pour une gestion simplifiée.",
    teachersTab: "C’est ici que vous pouvez ajouter et gérer vos enseignants. Ajouter des enseignants vous permet de suivre leurs informations, planifier des cours et gérer les paiements plus efficacement.",
    addTeacher: "Ajoutez votre premier enseignant pour commencer à gérer votre activité de coaching plus efficacement",
    addCategory: "Ajoutez votre première catégorie",
    addStudent: "Ajoutez votre premier élève",
    addLesson: "Ajoutez votre premier cours",
    confirmStopTitle: "Arrêter la visite guidée ?",
    confirmStopDesc: "Vous êtes sûr de vouloir arrêter la visite guidée ? Vous pouvez toujours y accéder plus tard depuis la section d'aide dans vos paramètres de profil.",
    confirmStopAction: "Arrêter la visite",
    createLesson: "Utilisez ce bouton pour créer un nouveau cours. Vous pouvez définir la date, l’heure, la catégorie et assigner des élèves au cours.",
    welcome: {
      title: "Bienvenue sur ThePoppyApp !",
      subtitle: "Configurons votre compte en quelques étapes",
      step1: "Étape 1 : Créez votre première catégorie",
      step2: "Étape 2 : Créez votre premier élève",
      step3: "Étape 3 : Créez votre premier cours",
      step1Desc: "Tout d’abord, créons votre première catégorie. Les catégories vous aident à organiser vos services et à définir des tarifs différents pour chaque type de service proposé.",
      step2Desc: "À l’étape suivante, vous allez créer votre premier élève",
      step3Desc: "Enfin, vous pourrez créer votre premier cours et commencer à utiliser la plateforme pour gérer votre activité de coaching plus efficacement",
      skip: "Passer la visite",
      start: "Commencer la visite"
    },
    congrats: {
      title: "Félicitations !",
      subtitle: "Tout est prêt, vous pouvez commencer",
      description: "Vous avez terminé la configuration initiale et créé votre première catégorie, votre premier élève et votre premier cours. Vous êtes maintenant prêt à utiliser ThePoppyApp pour gérer votre activité de coaching plus efficacement. Si vous avez besoin d’aide, n’hésitez pas à contacter notre équipe support.",
      goToDashboard: "Aller au tableau de bord",
      createLesson: "Créer votre premier cours",
      later: "Plus tard"
    }
  },

    footer: {
      professional_platform: "La plateforme tout-en-un pour les écoles et les enseignants indépendants",
      change_language: "Changer de langue",
      product: "Produit",
      resources: "Ressources",
      company: "Entreprise",
      integrations: "Intégrations",
      customers: "Clients",
      community: "Communauté",
      careers: "Carrières",
      terms: "CGU",
      privacy: "Politique de confidentialité"
    }
  }
};

export type FrenchTranslations = typeof french.translation;
export default french;
